<template>
    <button
        :class="
            twMerge(
                'w-full rounded-full bg-base-doveGrey  text-[1rem]/[1.4] font-bold text-base-black sm:mx-auto sm:max-w-[290px] lg:w-fit lg:text-[1.25rem]/[1.4]',
            )
        "
    >
        <NuxtLink
            :to="$localePath(to)"
            class="slt-flex-center gap-2 py-3 pl-1 lg:py-4 lg:pl-7 lg:pr-6"
        >
            <slot />
            <SvgArrowForward24 class="!h-6 !w-6" />
        </NuxtLink>
    </button>
</template>

<script setup>
import { twMerge } from "tailwind-merge";

const { to } = defineProps({
    to: {
        type: String,
        required: true,
    },
});
</script>
